import * as React from 'react';
import { Card } from '../../../components/Card';
import { CardMatchEventFragment, getCardName } from '../Stats/utils';
import { CardIcon } from '../components/CardIcon';
import { TextLink } from '../../../components/ClickableText';
import { PlayerNameWithAvatar } from '../components/PlayerNameWithAvatar';
import { CardHeading } from '../../../components/CardHeading';
import { isNil } from '../../../utils/isNil';

interface Props {
  cards: CardMatchEventFragment[];
  editLink?: string;
  isSignedIn: boolean;
}

export const CardsCard: React.FC<Props> = ({ cards, editLink, isSignedIn }) => {
  return (
    <Card className="space-y-4 bg-white">
      <CardHeading>Cards</CardHeading>
      <ul className="space-y-3">
        {cards.map((card) => {
          return (
            <li
              key={card.id}
              className="w-full flex items-center justify-between"
            >
              <PlayerNameWithAvatar
                player={card.player}
                linkToPlayer={isSignedIn}
              />
              <CardIcon
                color={card.event}
                title={getCardName(card.event)}
                className="flex-shrink-0 ml-2"
              />
            </li>
          );
        })}
      </ul>
      {!isNil(editLink) ? (
        <p className="text-sm text-right">
          <TextLink to={editLink}>Edit</TextLink>
        </p>
      ) : null}
    </Card>
  );
};
